module.exports = __webpack_public_path__ + "img/nap.41204ad6.svg";